import { useCallback, useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Slider } from 'primereact/slider';
import { Toast } from "primereact/toast";

import { BalanceamentoDialog } from "../../../components/Dialogs/BalanceamentoDialog";
import { GraficoBalanceamento } from "../../../components/Graficos/GraficoBalanceamento";
import { GraficoPorSetor } from "../../../components/Graficos/GraficoPorSetor";
import Menu from "../../../components/Menu";

import { useReport } from "../../../context/report";

import api from "../../../services/api";

const OPTIONS_SETORES = [
    { label: 'Acabamento', value: 'Acabamento' },
    { label: 'Expedição de Tecido', value: 'Expedição de Tecido' },
    { label: 'Revisão', value: 'Revisão' },
    { label: 'Tecelagem', value: 'Tecelagem' },
    { label: 'Tingimento', value: 'Tingimento' },
]
const colors = ['#8e44ad', '#e67e22', '#1abc9c', '#2980b9', '#e74c3c'];

export default function BalanceamentoProducao() {
    const [data, setData] = useState([]);
    const [chartType, setChartType] = useState("bar");
    const [chartData, setChartData] = useState({});
    const [dailyChartData, setDailyChartData] = useState({});
    const [totalChartData, setTotalChartData] = useState({});
    const [initialDate, setInitialDate] = useState(new Date());
    const [finalDate, setFinalDate] = useState(new Date());
    const [goal, setGoal] = useState(25000);
    const [totalSetor, setTotalSetor] = useState([]);
    const [fontSize, setFontSize] = useState(20);
    const [isVisible, setIsVisible] = useState(false);
    const [metas, setMetas] = useState([]);
    const [somaMeta, setSomaMeta] = useState(25000 * 5);
    const [setor, setSetor] = useState(OPTIONS_SETORES[0].value);
    const [setorGoal, setSetorGoal] = useState(25000);
    const [porSetorVisible, setPorSetorVisible] = useState(false);

    const { printing, handlePrint } = useReport();

    const toast = useRef();

    const showError = (error) => toast.current.show({ summary: 'Ocorreu um Erro', severity: 'error', detail: error.response ? error.response.data.message : error.message });
    const showSuccess = (response) => toast.current.show({ summary: 'Sucesso', severity: 'success', detail: response.data.message });

    const generateChart = (_data, goal, type = 1) => {
        let _labels = [];
        let setores = [];

        _data.forEach(item => {
            if(_labels.indexOf(item.data) === -1) {
                _labels.push(item.data);
            }

            if(setores.indexOf(item.setor) === -1) {
                setores.push(item.setor);
            }
        });

        _labels = _labels.sort((a, b) => {
            return new Date(a) - new Date(b);
        })

        let datasets = [];

        let i = 0;

        setores.forEach((item) => {
            let arrayValues = [];

            let dataSetor = _data.filter((element) => { return element.setor === item });
            let listColors = [];

            _labels.forEach(date => {
                let prod = dataSetor.find(element => { return element.data === date });
                if(prod) {
                    arrayValues.push(prod.soma);
                    if(prod.soma > goal) {
                        listColors.push('#2ecc71')
                    } else {
                        listColors.push('#e74c3c');
                    }
                } else {
                    arrayValues.push(0);
                    listColors.push('#e74c3c');
                }
            });

            let color = colors[i];

            datasets.push({
                label: item,
                data: arrayValues,
                backgroundColor: (type !== 2) ? color : listColors,
                borderColor: color
            });

            i += 1;
        });

        _labels = _labels.map(item => {
            return String(item).substring(item.length -2, item.length) + '-' + String(item).substring(item.length - 5, item.length -3)
        });

        let _chartData = {};
        _chartData.labels = _labels;
        _chartData.datasets = datasets;

        if(type === 1) {
            setChartData(_chartData);
        } else if(type === 2) {
            setDailyChartData(_chartData);
        } else {
            setTotalChartData(_chartData);
        }
    }

    useEffect(() => {
        if(data.length === 0)
            return

        let _data = [...data];
        let _setorGoal = goal;
        let metaSetor = null;
        let _setor = setor;
        let dataSetor = _data.filter((el) => { return el.setor === _setor });

        let somaMetas = 0;

        metas.forEach((item) => {
            somaMetas += parseFloat(item.meta);
        });

        setSomaMeta(somaMetas);

        metaSetor = metas.find((el) => { return el.setor_nome === _setor });
        if(metaSetor) {
            _setorGoal = metaSetor.meta;
            setSetorGoal(_setorGoal);
        }

        let dias = [];
        
        _data.forEach((item) => {
            if(dias.indexOf(item.data) === -1) {
                dias.push(item.data);
            }
        });

        let dadosTotal = [];
        dias.forEach((dia) => {
            let filtroDia = _data.filter((el) => { return el.data === dia });
            let total = 0;
            filtroDia.forEach((item) => {
                total += parseFloat(item.soma);
            });
            dadosTotal.push({ 'data': dia, 'setor': 'Geral', 'soma': total });
        });

        generateChart(_data, goal, 1);
        generateChart(dataSetor, _setorGoal, 2);
        generateChart(dadosTotal, somaMeta, 3);
    }, [data, goal, metas, setor, somaMeta]);

    const handlesearch = () => {
        api.get('balanceamento-producao', {
            params: {
                data_inicial: initialDate.getFullYear() + '-' + String(initialDate.getMonth() + 1).padStart(2, '0') + '-' + String(initialDate.getDate()).padStart(2, '0'),
                data_final: finalDate.getFullYear() + '-' + String(finalDate.getMonth() + 1).padStart(2, '0') + '-' + String(finalDate.getDate()).padStart(2, '0'),
            }
        }).then(response => {
            setData(response.data.dados);
            setTotalSetor(response.data.total_setor);
        }).catch(error => {
            showError(error);
        });
    }

    const fetchData = useCallback(() => {
        api.get('balanceamento-metas').then(response => {
            setMetas(response.data);
        }).catch(error => {
            setMetas([]);
        });
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    useEffect(() => {
        let _fontSize = localStorage.getItem('balanceamentoFontSize');
        if(_fontSize) {
            setFontSize(parseInt(_fontSize));
        }

        api.get('balanceamento-producao').then(response => {
            setData(response.data.dados);
            setTotalSetor(response.data.total_setor);
        }).catch(error => {
            showError(error);
        });
    }, []);

    return (
        <div>
            <Menu />
            <Toast ref={toast} />

            <Card
                className="m-1"
                title='Balanceamento de Produção'
            >
                <div className="p-d-flex p-flex-row p-p-justify-between">
                    <div>
                        <Calendar 
                            className="p-m-1"
                            dateFormat="dd/mm/yy"
                            mask="99/99/9999"
                            onChange={e => setInitialDate(e.value)}
                            value={initialDate}
                        />

                        <Calendar 
                            className="p-m-1"
                            dateFormat="dd/mm/yy"
                            mask="99/99/9999"
                            onChange={e => setFinalDate(e.value)}
                            value={finalDate}
                        />

                        <Button 
                            className="p-m-1"
                            icon="pi pi-search"
                            onClick={handlesearch}
                        />
                    </div>
                    <Button 
                        className="p-m-1"
                        icon="pi pi-plus"
                        onClick={() => {
                            setIsVisible(true);
                        }}
                    />
                </div>

                <div className="p-d-flex p-flex-row">
                    <Button 
                        className="p-m-1"
                        icon='pi pi-print'
                        onClick={() => handlePrint('grafico1')}
                    />
                    <Button 
                        className="p-m-1"
                        icon={chartType !== "bar" ? "pi pi-chart-line" : "pi pi-chart-bar"}
                        onClick={() => setChartType(chartType === "bar" ? "line" : "bar")}
                    />

                    <InputText
                        className="p-m-1"
                        onChange={e => setGoal(e.target.value)}
                        type="number"
                        value={goal}
                    />

                    <Slider 
                        className="p-m-1"
                        min={11}
                        max={28}
                        onChange={e => {
                            localStorage.setItem('balanceamentoFontSize', e.value);
                            setFontSize(e.value)
                        }}
                        style={{ alignSelf: 'center', width: '14rem' }}
                        value={fontSize}
                    />
                </div>

                <div className="p-d-flex p-flex-row">
                    <Button
                        className="p-m-1 p-button-success"
                        label={"Relatório por Setor"}
                        onClick={() => setPorSetorVisible(!porSetorVisible) }
                    />
                    <GraficoPorSetor
                        visible={porSetorVisible}
                        onHide={() => setPorSetorVisible(false)}
                    />
                </div>

                {totalSetor.map((item, index) => (
                    <div key={index}>
                        <b>{item.setor}: {Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 }).format(item.total)}m</b>
                    </div>
                ))}

                <BalanceamentoDialog 
                    dismiss={() => setIsVisible(false)}
                    fetchData={fetchData}
                    metas={metas}
                    showError={showError}
                    showSuccess={showSuccess}
                    visible={isVisible}
                />

                <GraficoBalanceamento
                    chartId='grafico1'
                    chartType={chartType}
                    chartData={chartData}
                    fontSize={fontSize}
                    goal={goal}
                    printing={printing}
                />

                <GraficoBalanceamento 
                    chartId='grafico3'
                    chartType={chartType}
                    chartData={totalChartData}
                    fontSize={fontSize}
                    goal={somaMeta}
                    printing={printing}
                />

                <hr></hr>
                <br></br>
                <div className="p-d-flex p-flex-row">
                    <Dropdown
                        className="p-col-4"
                        onChange={e => setSetor(e.value)}
                        options={OPTIONS_SETORES}
                        value={setor}
                    />

                    <Button 
                        className="p-m-1"
                        icon="pi pi-print"
                        onClick={() => handlePrint('grafico2')}
                    />
                </div>

                <GraficoBalanceamento
                    chartId='grafico2'
                    chartType={chartType}
                    chartData={dailyChartData}
                    fontSize={fontSize}
                    goal={setorGoal}
                    printing={printing}
                    setor={setor}
                />
            </Card>
        </div>
    )
};